module.exports = __webpack_public_path__ + "assets/vehicle_map_suv.68ed5eb8.svg";